import { ACTIONS } from "./adminConfig";

export default function ContentEditor({
	selectedItem,
	activeAction,
	formState,
	handleChange,
	handleSubmit,
	resetForm,
	status,
}) {
	return (
		<section className="admin-panel">
			<div className="panel-head">
				<div>
					<p className="panel-overline">{selectedItem.api ? `API · ${selectedItem.api}` : "Bloc statique"}</p>
					<h2>{selectedItem.label}</h2>
					<p className="panel-sub">Crée, modifie ou supprime le contenu de ce module.</p>
				</div>
				<div className="panel-hint">Choisis une action, remplis les champs, puis valide.</div>
			</div>

			<form className="admin-form" onSubmit={handleSubmit}>
				<div className="form-grid">
					<label className="form-field">
						<span>Titre</span>
						<input
							type="text"
							name="titre"
							placeholder="Titre visible côté client"
							value={formState.titre}
							onChange={handleChange}
							required={activeAction !== "delete"}
						/>
					</label>
					<label className="form-field">
						<span>Média / URL</span>
						<input
							type="text"
							name="media"
							placeholder="https://... ou chemin local"
							value={formState.media}
							onChange={handleChange}
							required={activeAction === "create"}
						/>
					</label>
					<label className="form-field">
						<span>Ordre / priorité</span>
						<input
							type="number"
							name="ordre"
							placeholder="1, 2, 3..."
							value={formState.ordre}
							onChange={handleChange}
						/>
					</label>
				</div>

				<label className="form-field">
					<span>Description</span>
					<textarea
						name="description"
						rows={4}
						placeholder="Texte, accroche ou note interne"
						value={formState.description}
						onChange={handleChange}
						required={activeAction === "create" || activeAction === "update"}
					/>
				</label>

				<div className="form-actions">
					<button type="button" className="btn ghost" onClick={resetForm}>
						Réinitialiser
					</button>
					<button type="submit" className="btn">
						{ACTIONS.find((a) => a.id === activeAction)?.label}
					</button>
				</div>
			</form>

			{status && (
				<div className="admin-status" data-type={status.type}>
					{status.message}
				</div>
			)}
		</section>
	);
}
